import React from 'react';
import { useDispatch } from 'react-redux';
import { VerticalTimelineElement } from 'react-vertical-timeline-component';
import Close from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';

import { createNewEmployee } from '../../../../store/actions/employee';


export const ApplicationItem = (props) => {
  const {
    title,
    name,
    label,
    date,
    employeeId,
    id,
    reload,
  } = props;

  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    const info = {
      employee: {
        id: employeeId,
      },
      disables: {
        settingsFuture: [
          {
            title,
            name,
            label,
            date,
            id,
          },
        ],
      },
    };

    dispatch(createNewEmployee(info, 'Configuração excluída com sucesso'))
      .then(() => {
        handleClose();
        reload();
      });
  };

  return (
    <>
      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ boxShadow: 'none', padding: '0.5em' }}
        style={{ margin: '1em 0' }}
        iconStyle={{
          background: '#537ccd',
          color: '#fff',
          width: '24px',
          height: '24px',
          margin: '8px',
          cursor: 'pointer',
        }}
        icon={
          <Tooltip
            title="Excluir"
            aria-label="Excluir aplicação"
            placement="top"
          >
            <Close onClick={() => handleClickOpen()} />
          </Tooltip>
        }
      >
        <h3 className="vertical-timeline-element-title">{title}</h3>
        <h4 className="vertical-timeline-element-subtitle">{name || 'nenhuma'}</h4>
        <h3 className="vertical-timeline-element-title">{label}</h3>
        <h4 className="vertical-timeline-element-subtitle">{date}</h4>
      </VerticalTimelineElement>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Deseja excluir essa configuração?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Essa configuração não será mais aplicada
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            CANCELAR
          </Button>
          <Button onClick={handleDelete} color="primary" variant="contained">
            EXCLUIR
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
